import styles from './TenantSelector.module.css';
import type { TenantSyncModeSelectorProps } from './types';

const DRAFT_DEFAULT_BADGE = 'Default for new';

export function TenantSyncModeSelector({
  mode,
  onModeChange,
  includeDraftOption,
  allTenantsSelectionDescription,
  selectedTenantsSelectionDescription,
  draftSelectionDescription,
  disabled,
}: TenantSyncModeSelectorProps) {
  return (
    <fieldset className={styles.modeOptions}>
      {includeDraftOption && (
        <label>
          <input
            type="radio"
            name="tenant-sync-mode"
            checked={mode === 'draft'}
            onChange={() => onModeChange('draft')}
            disabled={disabled}
          />
          <span className={styles.modeHeader}>
            <span className={styles.modeTitle}>Keep as draft</span>
            <span className={styles.modeBadge}>{DRAFT_DEFAULT_BADGE}</span>
          </span>
          <span className={styles.modeDescription}>{draftSelectionDescription}</span>
        </label>
      )}
      <label>
        <input
          type="radio"
          name="tenant-sync-mode"
          checked={mode === 'all'}
          onChange={() => onModeChange('all')}
          disabled={disabled}
        />
        <span className={styles.modeTitle}>All tenants (current and new)</span>
        <span className={styles.modeDescription}>{allTenantsSelectionDescription}</span>
      </label>
      <label>
        <input
          type="radio"
          name="tenant-sync-mode"
          checked={mode === 'selected'}
          onChange={() => onModeChange('selected')}
          disabled={disabled}
        />
        <span className={styles.modeTitle}>Selected tenants only</span>
        <span className={styles.modeDescription}>{selectedTenantsSelectionDescription}</span>
      </label>
    </fieldset>
  );
}
